export const ECountries = {
  UNITED_STATES: "US",
  CANADA: "CA",
} as const;

export type ECountries = (typeof ECountries)[keyof typeof ECountries];

export const CountryOptions = [
  {
    label: "United States",
    value: ECountries.UNITED_STATES,
  },
  {
    label: "Canada",
    value: ECountries.CANADA,
  },
] as const;
